import React, { useContext, useEffect, useState } from "react";
import axios from "../../../Axios";
import Loader from "../../Loader";
import { Urls } from "../../../Urls";
import { toast } from "react-toastify";
import { isMobile } from "../../../Constants";
import ProfileModal from "../../TransporterClientScreen/ProfileModal/ProfileModal";
import Rating from "react-rating";
//import Autosuggestor from "../AutoComplete/AutoCompleteTransporter";
import AutoComplete from "../AutoComplete/AutocompletetransporterV2";
import "./NewEnquiry.css";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";
import styles from "./MyLsp.module.css";

const MyLsp = ({ setmastertransporterlist, planningbutton }) => {
  const [newtransporter_list, setnewtransporter_list] = useState([]);
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  useEffect(() => {
    setShow(true);
    axios
      .get(`${Urls.user_data}?field=spot_recommended`)
      .then((r) => {
        setnewtransporter_list(r.data.spot_transporter_list);
        setShow(false);
      })
      .catch((e) => {
        console.log(e);
        setShow(false);
      });
  }, []);

  const addtomainlist = (e) => {
    var list = [];
    var temp = newtransporter_list;
    if (temp && temp.length > 0) {
      temp.map((data) => list.push(data.transporter_name));
    }
    if (!list.includes(e.transporter_name)) {
      setnewtransporter_list((prev) => [...prev, e]);
      setSearchText("");
    } else {
      toast.info("Transporter already exists");
      setSearchText("");
      return false;
    }
  };

  const deleteHandler = async (e, item) => {
    var trans = newtransporter_list.filter(
      (enq) => enq.transporter_id !== item.transporter_id
    );
    setnewtransporter_list(trans);
  };

  const handleChangeTransporter = (e) => {
    var temp = newtransporter_list;
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - add recommended transporters",
      Data: `transporter ids: ${temp.map((lsp) => lsp.transporter_id)}`,
      Definition: `user has clicked on submit recommended transporters`,
    });
    var payload = { spot_transporter_list: temp };
    setShow(true);
    axios
      .post(`${Urls.user_data}`, payload)
      .then(() => {
        setmastertransporterlist(newtransporter_list);
        toast.success("Transporter Saved Successfully!");
        setShow(false);
      })
      .catch((err) => {
        console.log(err);
        setShow(false);
      });
  };

  const savesearch = (e) => {
    setSearchText(e);
    setTimeout(() => setSearchText(""), 0);
  };

  return (
    <div>
      <Loader show={show} />

      {/* Summary bar */}
      {!show && newtransporter_list.length > 0 && (
        <div className={styles.summaryBar}>
          <span className={styles.summaryCount}>
            <i className="fa fa-users" style={{ marginRight: "8px" }} />
            {newtransporter_list.length}{" "}
            {newtransporter_list.length === 1 ? "Transporter" : "Transporters"} Added
          </span>
        </div>
      )}

      {/* Transporter card list */}
      <div className={styles.transporterListContainer}>
        {newtransporter_list && newtransporter_list.length > 0 ? (
          newtransporter_list.map((item, index) => (
            <div className={styles.transporterCard} key={`lsp-${index}`}>
              {/* Serial number */}
              <span className={styles.serialNum}>{index + 1}</span>

              {/* Name (profile modal link) */}
              <div className={styles.nameWrap}>
                <ProfileModal
                  transporter_list={newtransporter_list}
                  transporter_id={item.transporter_id}
                  transporter_name={item.transporter_name}
                  moduleName="LoRRI Spot"
                  screenName="My Enquiries"
                  buttonClass={styles.profileButton}
                />
              </div>

              {/* Rating */}
              <div className={styles.ratingWrap}>
                <Rating
                  initialRating={item && item.overall_rating ? item.overall_rating : 0}
                  readonly={true}
                  emptySymbol={`fa fa-star-o ${styles.starEmpty}`}
                  fullSymbol={`fa fa-star ${styles.starFull}`}
                />
              </div>

              {/* Delete button */}
              {!planningbutton && (
                <button
                  className={styles.deleteBtn}
                  onClick={(e) => deleteHandler(e, item)}
                  title="Remove transporter"
                >
                  <i className="fa fa-trash" />
                </button>
              )}
            </div>
          ))
        ) : (
          !show && (
            <div className={styles.noTransporters}>
              <i className={`fa fa-inbox ${styles.emptyIcon}`} />
              <span>No recommended transporters added yet.</span>
            </div>
          )
        )}
      </div>

      {/* Add Transporter input */}
      {!planningbutton && (
        <>
          <div className={styles.addInputWrap}>
            <AutoComplete
              value={searchText}
              onChange={setSearchText}
              onSelect={savesearch}
              placeholder="Add Transporter"
              getResults={addtomainlist}
          type="transporter"
        />
          </div>

          <div className={styles.saveWrap}>
            <button
              className={styles.saveBtn}
              onClick={(e) => handleChangeTransporter(e)}
            >
              <i className="fa fa-save" style={{ marginRight: "6px" }} />
              Save
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MyLsp;
